import { useState } from 'react';

const Switch = ({ initialChecked = false, dense=false, onToggle }) => {

    const [checked, setChecked] = useState(initialChecked);

    const handleChange = (e) => {
        setChecked(e.target.checked);
        if (onToggle) {
            onToggle(e.target.checked);            
        }
    };

    return (
        <div className="Switch">
            <label>
                <input type="checkbox" value="1" checked={checked} onChange={handleChange} />
                <div className={`SwitchWrapper ${dense ? "dense" : ""}`}>
                    <div className="SwitchState"></div>
                </div>
            </label>
        </div>
    )
}

export default Switch;